import React from 'react';
import { CHECKOUT_URL, CTA_LABEL } from '../data/landing';
export function CTAButton({
  className = ''
}: {
  className?: string;
}) {
  return <a href={CHECKOUT_URL} target="_self" className={`inline-flex w-full items-center justify-center whitespace-nowrap rounded-xl bg-gold px-8 py-4 font-sans text-[17px] font-semibold text-ink transition-[background-color,transform] duration-150 ease-out-strong hover:bg-gold-light active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ivory focus-visible:ring-offset-2 focus-visible:ring-offset-ink md:w-auto md:px-14 ${className}`} data-id="element-12" data-mp="2638h6i1s013p">
      {CTA_LABEL}
    </a>;
}